import React from "react";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var Textarea = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, placeholder = _a.placeholder, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.rows, rows = _e === void 0 ? 4 : _e, cols = _a.cols, maxLength = _a.maxLength, minLength = _a.minLength, _f = _a.size, size = _f === void 0 ? "medium" : _f, _g = _a.state, state = _g === void 0 ? "default" : _g, _h = _a.resize, resize = _h === void 0 ? "vertical" : _h, label = _a.label, helpText = _a.helpText, errorMessage = _a.errorMessage, successMessage = _a.successMessage, icon = _a.icon, _j = _a.fullWidth, fullWidth = _j === void 0 ? false : _j, _k = _a.className, className = _k === void 0 ? "" : _k, _l = _a.autoFocus, autoFocus = _l === void 0 ? false : _l, _m = _a.wrap, wrap = _m === void 0 ? "soft" : _m;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    // Determine the actual state based on messages
    var actualState = errorMessage ? "error" : successMessage ? "success" : state;
    // Determine status icon
    var statusIcon = actualState === "error" ? faExclamationCircle : actualState === "success" ? faCheckCircle : icon;
    var wrapperClasses = [
        "lib-textarea-wrapper",
        "lib-textarea-".concat(size),
        "lib-textarea-".concat(actualState),
        "lib-textarea-resize-".concat(resize),
        disabled ? "lib-textarea-disabled" : "",
        readOnly ? "lib-textarea-readonly" : "",
        fullWidth ? "lib-textarea-full-width" : "",
        statusIcon ? "lib-textarea-with-icon" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");
    var textareaClasses = ["lib-textarea", actualState !== "default" ? "lib-textarea-".concat(actualState) : ""]
        .filter(Boolean)
        .join(" ");
    return (React.createElement("div", { className: wrapperClasses },
        label && (React.createElement("label", { htmlFor: id, className: "lib-textarea-label" },
            label,
            required && React.createElement("span", { className: "lib-textarea-required" }, "*"))),
        React.createElement("div", { className: "lib-textarea-container" },
            statusIcon && (React.createElement(FontAwesomeIcon, { icon: statusIcon, className: "lib-textarea-icon ".concat(actualState !== "default" ? "lib-textarea-icon-".concat(actualState) : "") })),
            React.createElement("textarea", { id: id, name: name, className: textareaClasses, value: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, placeholder: placeholder, disabled: disabled, readOnly: readOnly, required: required, rows: rows, cols: cols, maxLength: maxLength, minLength: minLength, autoFocus: autoFocus, wrap: wrap, style: { resize: resize } })),
        helpText && !errorMessage && !successMessage && React.createElement("div", { className: "lib-textarea-help" }, helpText),
        errorMessage && React.createElement("div", { className: "lib-textarea-error" }, errorMessage),
        successMessage && React.createElement("div", { className: "lib-textarea-success" }, successMessage),
        maxLength && (React.createElement("div", { className: "lib-textarea-counter" },
            value.length,
            " / ",
            maxLength))));
};
export default Textarea;
